import { ImportOrderData, UpsertOrder } from '../redux/api/orders/orders.model';
import {
  FLOWS,
  ValidationPayload,
  ValidationTrips
} from '../redux/api/validationsHelper/validationsHelper.model';

class DispatchHelperUtils {
  /**
   * Returns payload for orders flow
   * @param loadData
   * @param enableLtl
   * @returns
   */
  static getValidateDispatchPayload(
    loadData: UpsertOrder | ImportOrderData,
    enableLtl: boolean,
    orderId?: string
  ): { data: ValidationPayload } {
    const payload: ValidationPayload = {
      flow: FLOWS.ORDERS,
      customer_order_number: loadData.customer_order_number,
      trips: [],
      ...(orderId && { order_id: orderId })
    };

    if (enableLtl) {
      const trips = loadData.stops
        ? loadData.stops.map((stop) => {
            return {
              start_date: stop.start_date,
              stop_date: stop.end_date,
              start_from_time: stop.start_time,
              stop_from_time: stop.end_time
            } as ValidationTrips;
          })
        : undefined;

      return { data: { ...payload, trips } };
    }

    const trips = loadData.trips
      ? loadData.trips.map((trip) => {
          return {
            drivers: trip.drivers,
            truck_id: trip.truck_id,
            trailer_id: trip.trailer_id,
            start_date: trip.stops[0].start_date,
            stop_date: trip.stops[trip.stops.length - 1].end_date,
            start_from_time: trip.stops[0].start_time,
            stop_from_time: trip.stops[trip.stops.length - 1].start_time
          } as ValidationTrips;
        })
      : undefined;

    return { data: { ...payload, trips } };
  }
}

export default DispatchHelperUtils;
